import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotFoundComponent } from './not-found.component';
import { Routes, RouterModule } from '@angular/router';
import { TextModule } from 'src/app/dynamic-module/lib/ui-kit/text/text.module';
import { ButtonModule } from 'src/app/dynamic-module/lib/ui-kit/button/button.module';
import { DYNAMIC_COMPONENT } from 'src/app/shared/dynamic-component-loader/dynamic-component.manifest';
import { SharedModule } from 'src/app/shared/shared.module';
import { PanelsModule } from 'src/app/shared/components/panels/panels.module';


@NgModule({
  declarations: [NotFoundComponent],
  exports: [NotFoundComponent],
  imports: [
    RouterModule,
    CommonModule,
    TextModule, 
    ButtonModule,
    SharedModule,
    PanelsModule,
  ],
  providers: [
    {provide: DYNAMIC_COMPONENT, useValue: NotFoundComponent},
  ],
})
export class NotFoundModule { }
